import { MetaErrorCodes, type BaseError } from '@cplug/frontend-core/models'

/** Meta estável aceito pelo detector (não depender só de `message`). */
export const LEGAL_TERM_TEMPLATES_LIST_META_KEY = 'legalTermTemplates' as const

export const LEGAL_TERM_TEMPLATES_ADDRESS_MISSING_META = 'company_address_not_configured' as const

function isLegacyCompanyAddressNotConfiguredMessage (message?: string): boolean {
  const normalized = message?.trim().toLowerCase() ?? ''
  return normalized.includes('address not configured')
}

export function isCompanyAddressNotConfiguredError (error: BaseError): boolean {
  if (error.meta?.[LEGAL_TERM_TEMPLATES_LIST_META_KEY] === LEGAL_TERM_TEMPLATES_ADDRESS_MISSING_META) {
    return true
  }

  if (readCompanyAddressMeta(error) === MetaErrorCodes.Empty) {
    return true
  }

  return isLegacyCompanyAddressNotConfiguredMessage(error.message)
}

function readCompanyAddressMeta (error: BaseError): MetaErrorCodes | undefined {
  const company = error.meta?.company
  if (company == null || typeof company !== 'object' || Array.isArray(company)) {
    return undefined
  }

  // O backend serializa `company.address` como array de validações (ex.: [Empty]).
  const address = (company as { address?: MetaErrorCodes | MetaErrorCodes[] }).address
  if (Array.isArray(address)) {
    return address.find(value => value != null)
  }

  return address
}
